import React from "react";
import "./index.css";

export interface PortalCustomField {
  tcf_id: number;
  tcf_description: string;
  tcf_alternativeidentifier?: string;
  fte_id?: number;
  tcf_active?: number;
}

interface CalendarCustomFieldFiltersProps {
  fields: PortalCustomField[];
  values: Record<string, string>;
  onChange: (tcfId: string, value: string) => void;
  embedded?: boolean;
}

const CalendarCustomFieldFilters: React.FC<CalendarCustomFieldFiltersProps> = ({
  fields,
  values,
  onChange,
  embedded = false,
}) => {
  if (!fields.length) {
    return null;
  }

  return (
    <div
      className={`calendar-custom-fields ${
        embedded ? "calendar-custom-fields--embedded" : ""
      }`}
    >
      {!embedded && (
        <h3 className="calendar-custom-fields-title">Campos customizados</h3>
      )}
      <div className="calendar-custom-fields-grid">
        {fields.map((field) => {
          const id = String(field.tcf_id);
          return (
            <div key={id} className="calendar-custom-field-group">
              <label
                className="calendar-filter-label"
                htmlFor={`custom-field-${id}`}
              >
                {field.tcf_description}
              </label>
              <input
                id={`custom-field-${id}`}
                type="text"
                className="calendar-custom-field-input"
                placeholder={`Buscar por ${field.tcf_description}`}
                value={values[id] || ""}
                onChange={(e) => onChange(id, e.target.value)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarCustomFieldFilters;
